<div class="ontario-columns ontario-small-12" style="padding: 0 2rem; width: 50vw">
    <h1> MTO Comment </h1>
    <h4> {{mtoComment.createDate | date: "MMMM dd, YYYY h:mm a"}} </h4>
    <h4> {{mtoComment.userName}} </h4>
    <p tabindex="0" role="scrollbar" class="comment-container">
        {{ mtoComment.comment }}
    </p>
    <button mat-dialog-close style="float:right" class="ontario-button ontario-button--primary">Close</button>
</div>